// Formatage de la date YYYY-MM-DD en DD/MM/YYYY
const formatDate = (date) => {
  if (!date) return ""; // Gérer les cas où la date est null ou undefined
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  return new Date(date).toLocaleDateString("fr-FR", options);
};

export default formatDate;